module.exports = __webpack_public_path__ + "img/productSatellite_29.38526b92.png";